module.exports = __webpack_public_path__ + "media/images/collapsedMap-60f87271cf47814b7450a323d041979a.svg";